import { Controller } from "@hotwired/stimulus";
import {
  client,
  hostedFields,
  paypalCheckout,
  googlePayment,
} from "braintree-web";
import { Toast } from "bootstrap5";
import { loadScript } from "lib/ajax";

export default class extends Controller {
  connect() {
    //     console.log(
    //       "braintree controller connect!!",
    //       this.element,
    //       this.data.get("hostedFields"),
    //       typeof this.data.get("hostedFields")
    //     );
    // console.log("DATA", this.data.get("paypalOnly"))

    if (this.data.get("hostedFields") == "true") {
      if (this.data.get("ccOnly") == "true") {
        this.initHostedOnly();
      } else if (this.data.get("hasDefault") == "true") {
        this.initWithDefaultPaymentMethod();
      } else {
        this.initHosted();
      }
    } else if (this.data.get("paypalOnly") == "true") {
      this.initPaypalOnly();
    } else {
      this.initWithDefaultPaymentMethod();
    }
  }

  createGooglePay(clientInstance) {
    var that = this;

    loadScript("https://pay.google.com/gp/p/js/pay.js").then(function () {
      var paymentsClient = new google.payments.api.PaymentsClient({
        environment:
          that.data.get("braintreeEnvironment") == "production"
            ? "PRODUCTION"
            : "TEST",
      });

      // if (googlePayment.isSupported()) {
      googlePayment.create(
        {
          client: clientInstance,
          googlePayVersion: 2,
          googleMerchantId: that.data.get("googlepayMerchantId"),
        },
        function (err, googlePaymentInstance) {
          if (err) {
            console.log(err);
          } else {
            paymentsClient
              .isReadyToPay({
                // see https://developers.google.com/pay/api/web/reference/object#IsReadyToPayRequest for all options
                apiVersion: 2,
                apiVersionMinor: 0,
                allowedPaymentMethods:
                  googlePaymentInstance.createPaymentDataRequest()
                    .allowedPaymentMethods,
                existingPaymentMethodRequired: true,
              })
              .then(function (isReadyToPay) {
                if (isReadyToPay.result) {
                  // Set up Google Pay button

                  // set up Pay with Google button
                  const container = document.getElementById(
                    "googlepay_container"
                  );
                  const button = paymentsClient.createButton({
                    buttonColor: "default",
                    buttonType: "plain",
                    onClick: (e) => {
                      var paymentRequestData;

                      e.preventDefault();

                      var paymentDataRequest =
                        googlePaymentInstance.createPaymentDataRequest({
                          transactionInfo: {
                            currencyCode: "USD",
                            totalPriceStatus: "FINAL",
                            totalPrice: $("input[name=amount]").val(), // your amount
                          },
                        });

                      paymentsClient
                        .loadPaymentData(paymentDataRequest)
                        .then(function (paymentData) {
                          return googlePaymentInstance.parseResponse(
                            paymentData
                          );
                        })
                        .then(function (payload) {
                          // send result.nonce to your server
                          // console.log(result)
                          $("input[name=payment_method_nonce]").val(
                            payload.nonce
                          );
                          $("input[name=payment_method_type]").val(
                            payload.type
                          );
                          // $('di_payment_submit').hide();
                          $("#di_payment_form").submit();
                        })
                        .catch(function (err) {
                          // handle errors
                        });
                    },
                    allowedPaymentMethods: [], // use the same payment methods as for the loadPaymentData() API call
                  });

                  container.appendChild(button);
                }
              });
          }
        }
      );
      return clientInstance;
      // }
    });
  }

  initWithDefaultPaymentMethod() {
    // window.braintree.setup(this.data.get("clientToken"), "custom", {
    //   dataCollector: {
    //     paypal: true,
    //     kount: {
    //       environment: this.data.get("braintreeEnvironment"),
    //     },
    //   },
    //   onReady: function (braintreeInstance) {
    //     this.deviceData = braintreeInstance.deviceData;
    //     $("input[name=device_data]").val(this.deviceData);
    //     // $('di_payment_submit').show();
    //   },
    // })

    client
      .create({
        authorization: this.data.get("clientToken"),
      })
      .catch(function (err) {
        alert(`Oops. Something went wrong. ${err}`);
        console.error(err);
        return;
      });
  }

  initHosted() {
    var that = this;
    client
      .create({
        authorization: this.data.get("clientToken"),
      })
      .then(function (clientInstance) {
        that.createHostedFields(clientInstance);
        return clientInstance;
      })
      .then(function (clientInstance) {
        that.createPaypalCheckout(clientInstance);
        return clientInstance;
      })
      // .then(function (clientInstance) {
      //   that.createGooglePay(clientInstance);
      //   return clientInstance;
      // })
      .catch(function (err) {
        alert(`Oops. Something went wrong. ${err}`);
        console.error(err);
        return;
      });
  }

  initHostedOnly() {
    var that = this;
    client
      .create({
        authorization: this.data.get("clientToken"),
      })
      .then(function (clientInstance) {
        that.createHostedFields(clientInstance);
        return clientInstance;
      })
      .catch(function (err) {
        alert(`Oops. Something went wrong. ${err}`);
        console.error(err);
        return;
      });
  }

  initPaypalOnly() {
    var that = this;
    client
      .create({
        authorization: this.data.get("clientToken"),
      })
      .then(function (clientInstance) {
        that.createPaypalCheckout(clientInstance);
        return clientInstance;
      })
      .catch(function (err) {
        alert(`Oops. Something went wrong. ${err}`);
        console.error(err);
        return;
      });
  }

  createPaypalCheckout(clientInstance) {
    paypalCheckout
      .create({
        client: clientInstance,
      })
      .then(function (paypalCheckoutInstance) {
        return paypalCheckoutInstance.loadPayPalSDK({ vault: true });
      })
      .then(function (paypalCheckoutInstance) {
        // The PayPal script is now loaded on the page and
        // window.paypal.Buttons is now available to use

        return paypal
          .Buttons({
            fundingSource: paypal.FUNDING.PAYPAL,

            createBillingAgreement: function () {
              return paypalCheckoutInstance.createPayment({
                flow: "vault", // Required

                // The following are optional params
                billingAgreementDescription: "Radio Airplay Service",
                enableShippingAddress: false,
              });
            },
            onApprove: function (data, actions) {
              return paypalCheckoutInstance.tokenizePayment(
                data,
                function (err, payload) {
                  // Submit 'payload.nonce' to your server
                  console.log("payload", payload);
                  $("input[name=payment_method_nonce]").val(payload.nonce);
                  $("input[name=payment_method_type]").val("PayPal");
                  // $('di_payment_submit').hide();
                  $("#di_payment_form").submit();
                }
              );
            },

            onCancel: function (data) {
              console.log(
                "PayPal payment canceled",
                JSON.stringify(data, 0, 2)
              );
            },

            onError: function (err) {
              console.error("PayPal error", err);
            },
          })
          .render("#paypal-button");
      })
      .catch(function (err) {
        alert(`Oops. Something went wrong. ${err}`);
        console.error("Paypal init error", err);
        return;
      });
  }

  createHostedFields(clientInstance) {
    var form = $("#di_payment_form");

    hostedFields
      .create({
        client: clientInstance,
        fields: {
          number: {
            selector: "#card-number",
            placeholder: "**** **** **** ****",
          },
          cvv: {
            selector: "#cvv",
            placeholder: "123",
          },
          expirationDate: {
            selector: "#expiration-date",
            placeholder: "MM/YYYY",
          },
        },
        styles: {
          input: {
            "font-size": "1rem",
          },
          ":focus": { color: "#333333" },
          ".valid": {
            color: "green",
          },
          ".invalid": { color: "#FF0000" },
        },
        ".number": {
          "font-family": "monospace",
        },
      })

      // .then(function (hostedFieldsInstance) {
      //   // Make tokenize call on form submission
      //   form.addEventListener(
      //     "submit",
      //     function (event) {
      //       event.preventDefault();

      //       hostedFieldsInstance.tokenize().then(function (payload) {
      //         // Submit payload.nonce to your server
      //       });
      //     },
      //     false
      //   );
      // });
      .then((hostedFieldsInstance) => {
        function createInputChangeEventListener(element) {
          return function () {
            validateInput(element);
          };
        }

        function setValidityClasses(element, validity) {
          if (validity) {
            element.removeClass("is-invalid");
            element.addClass("is-valid");
          } else {
            element.addClass("is-invalid");
            element.removeClass("is-valid");
          }
        }

        function validateInput(element) {
          // very basic validation, if the
          // fields are empty, mark them
          // as invalid, if not, mark them
          // as valid

          if (!element.val().trim()) {
            setValidityClasses(element, false);

            return false;
          }

          setValidityClasses(element, true);

          return true;
        }

        // function validateEmail() {
        //   var baseValidity = validateInput(email);

        //   if (!baseValidity) {
        //     return false;
        //   }

        //   if (email.val().indexOf("@") === -1) {
        //     setValidityClasses(email, false);
        //     return false;
        //   }

        //   setValidityClasses(email, true);
        //   return true;
        // }

        var ccName = $(".validateField");
        // var email = $("#email");

        ccName.on("change", function (_event) {
          validateInput($(this));
        });
        //email.on("change", validateEmail);

        hostedFieldsInstance.on("validityChange", function (event) {
          var field = event.fields[event.emittedBy];

          // Remove any previously applied error or warning classes
          $(field.container).removeClass("is-valid");
          $(field.container).removeClass("is-invalid");

          if (field.isValid) {
            $(field.container).addClass("is-valid");
          } else if (field.isPotentiallyValid) {
            // skip adding classes if the field is
            // not valid, but is potentially valid
          } else {
            $(field.container).addClass("is-invalid");
          }
        });

        hostedFieldsInstance.on("cardTypeChange", function (event) {
          var cardBrand = $("#card-brand");
          var cvvLabel = $('[for="cvv"]');

          if (event.cards.length === 1) {
            var card = event.cards[0];

            // change pay button to specify the type of card
            // being used
            cardBrand.text(card.niceType);
            // update the security code label
            cvvLabel.text(card.code.name);
          } else {
            // reset to defaults
            cardBrand.text("Card");
            cvvLabel.text("CVV");
          }
        });

        form.on("submit", function (event) {
          if ($("input[name=payment_method_nonce]").val() != "") {
            return true;
          }

          event.preventDefault();

          var formIsInvalid = false;
          var state = hostedFieldsInstance.getState();

          // perform validations on the non-Hosted Fields
          // inputs
          // if (!validateEmail()) {
          //   formIsInvalid = true;
          // }

          // Loop through the Hosted Fields and check
          // for validity, apply the is-invalid class
          // to the field container if invalid
          Object.keys(state.fields).forEach(function (field) {
            if (!state.fields[field].isValid) {
              console.log("isinvalid:", field, state.fields[field].container);
              $(state.fields[field].container).addClass("is-invalid");
              formIsInvalid = true;
            }
          });

          $(".validateField").each((i, e) => {
            console.log("validatefield", e);
            validateInput($(e));
          });

          if (formIsInvalid) {
            // skip tokenization request if any fields are invalid
            $(".dash_container").prepend(
              $(
                `<div style='z-index:99; top:10rem; left:50%; transform: translateX(-50%)' class="toast position-fixed align-items-center text-bg-danger border-0" role="alert" aria-live="assertive" aria-atomic="true">
                   <div class="d-flex">
                     <div class="toast-body">
                       Please check the highlighted fields and try again.
                     </div>
                     <button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button>
                  </div>
                </div>`
              )
            );
            const vtoast = Toast.getOrCreateInstance($(".toast")[0]);
            vtoast.show();
            return false;
          }

          hostedFieldsInstance.tokenize(function (err, payload) {
            if (err) {
              console.error(err);
              return false;
            }
            console.log("payload", payload);
            // This is where you would submit payload.nonce to your server
            //$(".toast").toast("show");

            // you can either send the form values with the payment
            // method nonce via an ajax request to your server,
            // or add the payment method nonce to a hidden inpiut
            // on your form and submit the form programatically
            // $('#payment-method-nonce').val(payload.nonce);
            // form.submit()
            $("input[name=payment_method_nonce]").val(payload.nonce);
            $("input[name=payment_method_type]").val(payload.type);
            // native event doesnt trigger jquery onsubmit event (again) since we are in submit handler now
            $("#di_payment_form")[0].submit();
          });
        });
      });
  }

  // initHostedOld() {
  //   console.log("initHosted", this);

  //   window.braintree.setup(this.data.get("clientToken"), "custom", {
  //     id: "di_payment_form",
  //     dataCollector: {
  //       paypal: true,
  //       kount: { environment: this.data.get("braintreeEnvironment") },
  //     },
  //     hostedFields: {
  //       number: {
  //         selector: "#card-number",
  //         placeholder: "**** **** **** ****",
  //       },
  //       cvv: {
  //         selector: "#cvv",
  //         placeholder: "123",
  //       },
  //       expirationDate: {
  //         selector: "#expiration-date",
  //         placeholder: "MM/YYYY",
  //       },

  //       styles: {
  //         input: {
  //           "font-size": "1rem",
  //         },
  //         ":focus": { color: "#333333" },
  //         ".valid": {
  //           color: "green",
  //         },
  //         ".invalid": { color: "#FF0000" },
  //       },
  //       ".number": {
  //         "font-family": "monospace",
  //       },

  //       onFieldEvent: function (event) {
  //         this.form_modified = true;
  //       },
  //     },
  //     paypal: {
  //       container: "pp_container",
  //       singleUse: false,
  //       currency: "USD",
  //       locale: "en_us",
  //       enableShippingAddress: false,
  //       displayName: "RadioAirplay.com",
  //       headless: true,
  //       billingAgreementDescription: "Radio Airplay Service",
  //       onSuccess: function (nonce) {
  //         //deprecated callback, but onPaymentMethodReceived not calling for pp
  //         console.log(nonce);

  //         if (this.did_submit) {
  //           console.log("in onSuccess: submit already");
  //         } else {
  //           this.did_submit = true;
  //           $("input[name=payment_method_nonce]").val(nonce);
  //           $("input[name=payment_method_type]").val("PayPal");
  //           // $('di_payment_submit').hide();
  //           $("#di_payment_form").submit();
  //         }
  //       },
  //     },
  //     onReady: function (braintreeInstance) {
  //       console.log("onready", this);
  //       console.log(braintreeInstance);
  //       this.checkout = braintreeInstance;
  //       this.deviceData = braintreeInstance.deviceData;
  //       $("input[name=device_data]").val(this.deviceData);
  //       // $('di_payment_submit').show();
  //       $(document)
  //         .off("click", "#pp_container img")
  //         .on("click", "#pp_container img", (event) => {
  //           this.checkout.paypal.initAuthFlow();
  //           event.stopPropagation();
  //         });
  //     },
  //     onPaymentMethodReceived: function (obj) {
  //       console.log(obj);

  //       if (this.did_submit) {
  //         return console.log("in onPaymentMethodReceived: submitted already");
  //       } else {
  //         //keep going
  //       }
  //       this.did_submit = true;
  //       $("input[name=payment_method_nonce]").val(obj.nonce);
  //       $("input[name=payment_method_type]").val(obj.type);
  //       // $('di_payment_submit').hide();
  //       $("#di_payment_form").submit();
  //     },
  //     onError: function (obj) {
  //       this.did_submit = false;
  //       console.log(obj);
  //       alert("Whoops. this didn't work. Please check the card and try again.");
  //       setTimeout(function () {
  //         $("#pay_now_button").removeAttr("disabled");
  //       }, 1000);
  //     },
  //   }); // braintree setup
  // }

  // paypalAuth(event) {
  //   this.checkout.paypal.initAuthFlow();
  //   event.stopPropagation();
  // }

  // initEdit() {
  //   console.log("initEdit");

  //   $("#di_payment_form")[0].reset();

  //   window.braintree.setup(this.data.get("clientToken"), "custom", {
  //       id: "di_payment_form",
  //     dataCollector: {
  //       kount: {
  //         environment: this.data.get("braintreeEnvironment"),
  //       },
  //     },
  //     onReady: function (braintreeInstance) {
  //       $("input[name=device_data]").val(braintreeInstance.deviceData);
  //     },
  //   });
  // }
}
